const chunkReloadKey = () => {
  const now = new Date();
  const pad = (value) => String(value).padStart(2, '0');
  return `trazal_chunk_reload_${now.getFullYear()}_${pad(now.getMonth() + 1)}_${pad(now.getDate())}_${pad(now.getHours())}`;
};

const isChunkLoadError = (message) => {
  if (!message) return false;
  return message.includes('Loading chunk')
    || message.includes('Loading CSS chunk')
    || message.includes("Unexpected token '<'");
};

const reloadOnceForChunkError = (message) => {
  if (!isChunkLoadError(message)) return;
  const key = chunkReloadKey();
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, '1');
  window.location.reload();
};

export const installChunkReload = () => {
  window.addEventListener('error', (event) => {
    reloadOnceForChunkError(event?.message || event?.error?.message);
  });

  window.addEventListener('unhandledrejection', (event) => {
    reloadOnceForChunkError(event?.reason?.message);
  });
};
